// Phase 1 — Frontend mirror of /app/backend/services/asset_type_defaults.py
// Keep in sync manually. Backend remains the source of truth (GET /studio/meta);
// this file is used for fallback icons + offline rendering.

import {
  Code, Heart, Target, GraduationCap, CloudSun, UserPlus, Award, FileText,
} from 'lucide-react';

export const ASSET_TYPE_ICONS = {
  technical: Code,
  behavioral: Heart,
  competency: Target,
  knowledge: GraduationCap,
  climate: CloudSun,
  onboarding: UserPlus,
  certification: Award,
  profile: Heart,
  generic: FileText,
};

export const STARTING_METHODS = [
  { code: 'blank',          labelKey: 'studio.starting.blank',          icon: FileText },
  { code: 'duplicate',      labelKey: 'studio.starting.duplicate',      icon: Target },
  { code: 'template',       labelKey: 'studio.starting.template',       icon: Award },
  { code: 'sample',         labelKey: 'studio.starting.sample',         icon: GraduationCap },
  { code: 'excel_import',   labelKey: 'studio.starting.excel',          icon: FileText },
  { code: 'word_import',    labelKey: 'studio.starting.word',           icon: FileText },
  { code: 'ai',             labelKey: 'studio.starting.ai',             icon: FileText, disabled: true },
];

export const LIFECYCLE_COLOR_MAP = {
  draft:                { tone: 'muted',  bg: 'bg-muted/50 text-foreground border-border' },
  submitted_for_review: { tone: 'amber',  bg: 'bg-amber-100 text-amber-900 border-amber-300 dark:bg-amber-500/20 dark:text-amber-200 dark:border-amber-500/40' },
  under_review:         { tone: 'amber',  bg: 'bg-amber-100 text-amber-900 border-amber-300 dark:bg-amber-500/20 dark:text-amber-200 dark:border-amber-500/40' },
  needs_revision:       { tone: 'orange', bg: 'bg-orange-100 text-orange-900 border-orange-300 dark:bg-orange-500/20 dark:text-orange-200 dark:border-orange-500/40' },
  approved:             { tone: 'blue',   bg: 'bg-blue-100 text-blue-900 border-blue-300 dark:bg-blue-500/20 dark:text-blue-200 dark:border-blue-500/40' },
  published:            { tone: 'green',  bg: 'bg-emerald-100 text-emerald-900 border-emerald-300 dark:bg-emerald-500/20 dark:text-emerald-200 dark:border-emerald-500/40' },
  deprecated:           { tone: 'orange', bg: 'bg-orange-100 text-orange-900 border-orange-300 dark:bg-orange-500/20 dark:text-orange-200 dark:border-orange-500/40' },
  archived:             { tone: 'red',    bg: 'bg-red-100 text-red-900 border-red-300 dark:bg-red-500/20 dark:text-red-200 dark:border-red-500/40' },
};

// Allowed forward transitions per current stage — mirrors the backend
// Library state machine. Approve / reject / publish / archive / revert are
// HM Admin only (UAT 07/14 Batch 1).
export const LIFECYCLE_TRANSITIONS = {
  draft:                 [{ to: 'approved', adminOnly: true, label: 'approve_direct' }, { to: 'submitted_for_review' }, { to: 'archived', adminOnly: true, label: 'archive' }],
  submitted_for_review:  [{ to: 'approved', adminOnly: true }, { to: 'needs_revision', adminOnly: true, label: 'request_changes' }],
  needs_revision:        [{ to: 'submitted_for_review' }, { to: 'archived', adminOnly: true, label: 'archive' }],
  approved:              [{ to: 'published', requiresPublishTarget: true, adminOnly: true }, { to: 'draft', adminOnly: true, label: 'revert_to_draft' }, { to: 'archived', adminOnly: true, label: 'archive' }],
  published:             [{ to: 'approved', adminOnly: true, label: 'revert_to_approved' }, { to: 'draft', adminOnly: true, label: 'revert_to_draft' }, { to: 'archived', adminOnly: true, label: 'archive' }],
  archived:              [{ to: 'draft', adminOnly: true, label: 'restore_to_draft' }],
};
